import { render, staticRenderFns } from "./EditMember.vue?vue&type=template&id=796b2dee&scoped=true"
import script from "./EditMember.vue?vue&type=script&lang=js"
export * from "./EditMember.vue?vue&type=script&lang=js"
import style0 from "./EditMember.vue?vue&type=style&index=0&id=796b2dee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796b2dee",
  null
  
)

export default component.exports